module.exports = __webpack_public_path__ + "static/media/ghana.c820674d.gif";